export class Types {
    public static convertType<NewType>(obj: any): NewType {
        return (obj as unknown) as NewType
    }
}
